import React, { Children, Component, useEffect, useState } from 'react';
import { useSequenceStore } from '~/training/sequence/SequenceStore';
import { QUESTION_BRANCHING } from '..';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { t } from 'ttag';

export type QuestionBranchingDefinition = ItemDefinition<
  typeof QUESTION_BRANCHING,
  void
>;

interface CustomRenderProps<T> {
  id: string;
  extraItems: Array<any>
}

export class QuestionBranching extends Item<typeof QUESTION_BRANCHING, void> {
  protected render({ children }: RenderProps<void>) {
    const [alertAboutNextCard, setAlertAboutNextCard] = useState<string | null>(null);
    const [activeCard, setActiveCard] = useState(0);
    const answers = useSequenceStore(s => s.answers);
    const childArray = Children.toArray(children) as Array<Component<CustomRenderProps<void>>>;

    let returnNextData = true;
    const cardNumbers = [] as Array<number>;

    childArray.filter((c, i) => {
      if (answers[c?.props?.id] !== undefined) {
        const selectedId = answers[childArray[i]?.props?.id][0];

        c?.props?.extraItems[0]?.items?.map((ii: any) => {
          if (ii?.values?.answer && ii?.id == selectedId) {
            cardNumbers.push(i);
            returnNextData = false;
          }
        });
      }

      if (returnNextData) {
        cardNumbers.push(i);
      }

      return (i <= Object.keys(answers).length) ? returnNextData : false;
    });

    useEffect(() => {
      if (Object.keys(answers).length && activeCard != Object.keys(answers).length && Object.keys(answers).length < childArray.length) {
        setAlertAboutNextCard(t`Next card`);

        setTimeout(() => {
          setAlertAboutNextCard(null);
        }, 1500);
      }

      if (Object.keys(answers).length) {
        setActiveCard(Object.keys(answers).length);
      }
    }, [answers]);

    return (
      <>
        {alertAboutNextCard ? <span className='sr-only' aria-live='polite'>{alertAboutNextCard}</span> : false}
        {childArray?.filter((c, i) => {
          return (i <= Object.keys(answers).length && cardNumbers.includes(i)) || (answers[childArray[i - 1].props.id] !== undefined && cardNumbers.includes(i));
        })}
      </>
    );
  }
}

registry[QUESTION_BRANCHING] = QuestionBranching;
